import { Pipe, PipeTransform } from '@angular/core';
import { formatCentralTime } from '@bodyanalytics/data-models-ui';

/**
 * Render a stored instant's TIME in the business display timezone (Central) —
 * the time-side sibling of `CentralDatePipe`, the template seam over
 * {@link formatCentralTime} (`@bodyanalytics/data-models-ui`).
 *
 * Use instead of Angular's bare `| date: 'shortTime'` for slot/booking times:
 * the bare DatePipe renders in the viewer's browser timezone, so a 7:30 PM
 * CDT slot reads as 8:30 PM for an Eastern viewer — and once the DATE beside
 * it is CT-pinned via `| centralDate`, a browser-TZ time next to a CT date is
 * a self-contradictory pair (PR #2165 round-2 sec-ux finding). Pinning both
 * to Central keeps every booking surface consistent with the
 * `TIME_SLOTS_TIMEZONE_NOTE` copy ("Time slots shown in Central Time (CT)").
 *
 * Patterns are date-fns tokens; the default `'h:mm a'` matches Angular's
 * `'shortTime'` ("7:30 PM"). Pass e.g. `'MMM d, h:mm a'` for combined
 * date+time cells so the whole value is CT-pinned by ONE formatter.
 *
 * Nullish/empty input renders as an empty string (DatePipe parity);
 * malformed non-empty input degrades to the shared `'—'` placeholder.
 */
@Pipe({
  name: 'centralTime',
})
export class CentralTimePipe implements PipeTransform {
  transform(value: string | number | Date | null | undefined, pattern = 'h:mm a'): string {
    if (value === null || value === undefined || value === '') {
      return '';
    }
    return formatCentralTime(value, pattern);
  }
}
